import React, {useEffect, useState} from "react";
import helpers from "../../../../../js/helpers";
import useMobileBreakpoint from "@mindarc/arctheme-components/frontend/src/hooks/useMobileBreakpoint";

export const ProductTileSearchResults = ({
                                product,
                                swatches = [],
                                siblings,
                                show_add = false,
                                show_price_inline = false,
                                settings,
                                enableWishlist,
                                type = ''
                            }) => {
    const isMobile = useMobileBreakpoint("1024px");
    const currencyCode =  window.Alpine?.store('currency').getCurrencyCode();
    const currencySymbol =  window.Alpine?.store('currency').getCurrencySymbol();

    // Helper function to get price by currency code
    const getPriceByCurrency = (priceRanges, currency) => {
        const priceEntry = priceRanges?.find((item) => item.currency_code === currency);
        return priceEntry?.amount || 0; // Convert to proper price format
    };

    // Default prices from compare_at_price and price
    let minPrice = product?.price > 0 ? product?.price / 100 : 0;
    let maxPrice = product?.compare_at_price > 0 ? product?.compare_at_price / 100 : 0;

    // If presentment_price_ranges exist, extract prices for the current currency
    if (product?.presentment_price_ranges) {
        const presentmentMinPrice = getPriceByCurrency(product?.presentment_price_ranges?.min_variant_price, currencyCode);
        const presentmentMaxPrice = getPriceByCurrency(product?.presentment_price_ranges?.max_variant_price, currencyCode);

        // Use presentment prices only if they are available
        minPrice = presentmentMinPrice ?? minPrice;
        maxPrice = presentmentMaxPrice ?? maxPrice;
    }
    // Ensure that compare_at_price is treated as a "strike-through price" if higher
    const isOnSale = minPrice > 0 && minPrice < maxPrice;

    return (
        <>
            <a href={`/products/${product.handle}`} className="product-tile">
                <div className="product-tile__inner flex gap-[85px] lg:gap-[8px]">
                    <div className="product-tile__image">
                        <img
                            className={`h-auto w-[66px] lg:w-[90px]`}
                            src={product.image}
                            alt={product.name}
                            height={150}
                        />
                    </div>
                    <div className="product-tile__content w-[70px]">
                        <div className="product-tile__content-inner">
                            <div
                                className="product-tile__title h6 font-normal leading-[1.6] tracking-[2.05px] uppercase">
                                {product.title}
                            </div>
                            <div className="product-tile__price">
                                <div className="product__price" data-prodify-price-container="">
                                    {isOnSale ? (
                                        <>
                                            <span className="sr-only">Special Price</span>
                                            <div className="product__sale-price h6">
                                                {currencyCode} {currencySymbol}{minPrice.toFixed(0)}
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <span className="sr-only">Regular Price</span>
                                            <div className="product__price h6">
                                                {currencyCode} {currencySymbol}{minPrice.toFixed(0)}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="product-tile__swatches">
                                {swatches.map((swatch) => (
                                    <div
                                        key={swatch.id}
                                        className="product-tile__swatch"
                                        style={{backgroundColor: swatch.color}}
                                    />
                                ))}
                            </div>
                            <div className="product-tile__actions">
                                {show_add && (
                                    <button
                                        className="product-tile__add"
                                        onClick={() => {
                                        }}
                                    >
                                        Add to Cart
                                    </button>
                                )}
                                {enableWishlist && (
                                    <button
                                        className="product-tile__wishlist"
                                        onClick={() => {
                                        }}
                                    >
                                        Add to Wishlist
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </>
    );
};
